export const ACTION = '/Catalog/GetProductDetail';